import { atom } from 'jotai';
import { LiveStateUpdate } from '../util/Events/Messages';

export const LIVE_LAST_EVENTS = atom<LiveStateUpdate[]>([]);
export const LIVE_TIME = atom(null); // `null` means always use current date

export const LIVE_STREAM_MESSAGES = atom<LiveStateUpdate[]>([]);
export const LIVE_NEW_MESSAGES = atom<LiveStateUpdate[]>([]);
export const LIVE_NEW_NOTIFICATIONS = atom<LiveStateUpdate[]>([]);

export const LIVE_STREAM_SORTED = atom(get =>
  get(LIVE_STREAM_MESSAGES).sort(
    event => new Date(event.data.iso8601).getTime() - new Date(event.data.iso8601).getTime(),
  ),
);

export const LIVE_UPDATES_LATEST = atom(get => get(LIVE_STREAM_SORTED).slice(-1)[0]);
export const LIVE_UPDATES_LATEST_TEN = atom(get => get(LIVE_STREAM_SORTED).slice(-10));
